/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancel': {
    width: 230,
    height: 230,
    viewBox: '0 0 230 230',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#FFC001" cx="115" cy="115" r="115"/><path pid="1" d="M171.662 60.06L61.807 169.917M62.06 60.06l109.856 109.856" _stroke="#1D7F8A" stroke-width="4" stroke-linecap="square"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/cancel.js